let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3Y3Tr")).then(() => parcelRequire('kHg0E'));